import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faAngleDoubleUp, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

import { SubHeading } from '../../../components';
import { images } from '../../../constants';
import './LexemeAIHeader.css';
import '../Header.css';

const LexemeAIHeader = () => {
  const navigate = useNavigate();

  return (
    <div id="lexemeai-header">
      <div className="app__headerLexemeAI app__wrapper section__padding" style={{ gap: '4rem' }}>

        {/* LEFT IMAGE / LOGO */}
        <div className="app__wrapper_img">
          <div className="lexemeaiImage">
            <img src={images.lexemeAIIcon} alt="lexemeAIIcon" />
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="app__wrapper_info">

          <SubHeading title="Instructional Intelligence & Classroom Insights for Schools" />

          <div className="lexemeaiLogo">
            <FontAwesomeIcon className="lexemeaiIcon" icon={faLayerGroup} />
            <h1 className="app__header-h1">LexemeAI</h1>
          </div>

          <div className="lexemeai-points">
            <p>Classroom observation analysis</p>
            <p>Teaching and engagement insights</p>
            <p>AI-assisted instructional reviews</p>
            <p>Teacher development intelligence</p>
          </div>

          <div className="app__header_buttons">
            <div
              className="exploreTrack"
              onClick={() => navigate('/lexemeai')}
              style={{ cursor: 'pointer' }}
            >
              <div>Explore</div>
              <FontAwesomeIcon className="angleRightLogo" icon={faAngleDoubleRight} />
            </div>

            <FontAwesomeIcon
              onClick={() => {
                navigate('/');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="angleUpLogo"
              icon={faAngleDoubleUp}
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default LexemeAIHeader;
